module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "track-list"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.header) ? _c('h1', [_vm._v(_vm._s(this.header))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "tracks"
  }, _vm._l((_vm.tracks), function(track, index) {
    return ((_vm.skipfirst == true && index != 0) || _vm.skipfirst == false) ? _c('li', {
      key: index,
      class: {
        extended: track.plays > 0
      }
    }, [_c('a', {
      attrs: {
        "href": ("https://last.fm/music/" + (track.artist) + "/_/" + (track.track)),
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "artwork"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("secure")(track.artwork),
        "alt": track.track
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "track-time"
    }, [_c('span', [_vm._v(_vm._s(_vm.getTimestamp(track.timestamp, _vm.longdate)))])]), _vm._v(" "), (track.plays) ? _c('div', {
      staticClass: "track-plays"
    }, [_c('span', [_vm._v(_vm._s(track.plays + " play" + (track.plays == 1 ? "" : "s")))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "track-info"
    }, [_c('h1', [_vm._v(_vm._s(track.artist))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(track.track))])])])]) : _vm._e()
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa87f444"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/globals/TrackList.vue
// module id = 278
// module chunks = 1